<template>
  <div>
    <table class="table">
      <thead class="thead-light">
        <tr>
          <th>{{ $t(`text.admin.${productName}`) }}</th>
          <th v-if="showTranslation"></th>
          <th v-if="showArtnr">{{ $t("text.admin.artnr") }}</th>
          <th>{{ $t("text.admin.skapad") }}</th>
          <th>{{ $t("text.admin.andrad") }}</th>
          <th>{{ $t("Filer") }}</th>
          <template v-if="showAddAndDelete">
            <th><country-flag country="se" size="small" style="transform: scale(0.6);" class="ml-n3" /></th>
            <th class="text-center"><country-flag country="no" size="small" style="transform: scale(0.6);"
                class="ml-n3" /></th>
            <th class="text-center"><country-flag country="dk" size="small" style="transform: scale(0.6);"
                class="ml-n3" /></th>
          </template>
          <template v-else>
            <th class="text-center"><country-flag :country="langcode" size="small" style="transform: scale(0.6);"
                class="ml-n3" /></th>
          </template>
          <th align="right" class="py-1 text-nowrap text-right pr-1">
            <b-button v-show="showAddAndDelete" variant="success"
              @click.prevent="exportListToCsv(productCode)"><b-icon-download></b-icon-download></b-button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" v-bind:key="item.id">
          <td>{{ item.name }}</td>
          <td v-if="showTranslation">
            <small>{{ getValue(item, 'name', '') }}</small>
          </td>
          <td v-if="showArtnr">
            <small>{{ getValue(item, 'artnr') }}</small>
          </td>
          <td>
            <small v-if="showOriginal">{{ item.date | sv_date }}</small>
            <small v-if="showTranslation">{{ item.date | no_date }}</small>
            <!-- <small v-if="access_level == 3">{{ item.date | dk_date }}</small> -->
          </td>
          <td>
            <span v-if="item.log">
              <small v-if="access_level < 2">
                {{ item.log.changed | sv_date }}
                <small><strong>({{ item.log.user.name }})</strong></small>
              </small>
              <small v-if="access_level == 2">
                {{ item.log.changed | no_date }}
                <small><strong>({{ item.log.user.name }})</strong></small>
              </small>
            </span>
          </td>
          <td>
            <AdminAssetsList :artnr="item.artnr" type="docs"></AdminAssetsList>
          </td>
          <template v-if="showAddAndDelete">
            <td class="text-center px-1 py-2">
              <b-icon-check variant="success" font-scale="1.8" v-if="item.published"></b-icon-check>
            </td>
            <td class="text-center px-1 py-2 bg-light">
              <b-icon-check variant="success" font-scale="1.8"
                v-if="item.translations.no && item.translations.no.published"></b-icon-check>
            </td>
            <td class="text-center px-1 py-2 bg-secondary">
              <b-icon-check variant="success" font-scale="1.8"
                v-if="item.translations.dk && item.translations.dk.published"></b-icon-check>
            </td>
          </template>
          <template v-else>
            <td class="text-center px-1 py-2">
              <b-icon-check variant="success" font-scale="1.8" v-if="getValue(item, 'published')"></b-icon-check>
            </td>
          </template>
          <td align="right" class="py-1 text-nowrap pr-1">
            <b-button variant="primary"
              :to="{ name: `adm-${productCode}-edit`, params: { id: item._id } }"><b-icon-pencil-fill></b-icon-pencil-fill></b-button>
            <b-button v-show="showAddAndDelete" variant="danger"
              @click.prevent="deleteById(item._id, productName)"><b-icon-trash-fill></b-icon-trash-fill></b-button>
            <b-button v-show="showAddAndDelete" variant="success"
              @click.prevent="exportToCsv(item._id, productCode)"><b-icon-download></b-icon-download></b-button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          <th v-if="showTranslation"></th>
          <th></th>
          <th></th>
          <th></th>
          <th colspan="5" class="text-right">
            <b-button v-show="showAddAndDelete" variant="success"
              :to="{ name: `adm-${productCode}-add` }"><b-icon-plus></b-icon-plus>
              {{ $t(`text.admin.lagg-till-${productCode}`) }}</b-button>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import AdminListMixin from "@/mixins/AdminListMixin";
import AdminAccessMixin from "@/mixins/AdminAccessMixin";
import AdminAssetsList from "@/components/admin/AdminAssetsList";
export default {
  mixins: [AdminListMixin, AdminAccessMixin],
  components: {
    AdminAssetsList,
  },
  name: "AdminProductList",
  props: {
    data: {
      type: Array,
    },
    productName: {
      type: String,
      required: true
    },
    productCode: {
      type: String,
      required: true
    },
  },
  computed: {
    showArtnr() {
      return this.productCode !== "lh";
    }
  }
};
</script>

<style lang="scss" scoped></style>